<template>
  <div>
    <h1>AR List</h1>
    <ul class="list-group">
			<formAr/>
      <!-- <li class="list-group-item" v-for="item in list" :key="item.id" @click="$router.push({ name: 'ar.play', params: { activityId: item.id } })">{{ item.name }}</li> -->
      <li class="list my-2" v-for="item in list" :key="item.id" >
        <p> {{ item.name }} </p>
        <div class="icon">
          <div class="icon-go" @click="$router.push({ name: 'ar.play', params: { activityId: item.id } })">
            <img src="@/assets/images/btn_go_off.png" alt="">
            <img class="icon-img-hover" src="@/assets/images/btn_go_on.png" alt="">
          </div>
          <div class="icon-trash">
            <img src="@/assets/images/btn_delete_off.png" alt="">
            <img class="icon-img-hover" src="@/assets/images/btn_delete_on.png" alt="">
          </div>
        </div>
      </li>
    </ul>
		<pagination :current="1" :total="3"/>
  </div>
</template>

<script>
import api from '@/apiMixin'
import pagination from '@/components/Pagination.vue'
import formAr from '@/components/FormAR.vue'

export default {
  name: 'List',
	mixins: [api],

	components :{
		pagination,
		formAr
	},

  data () {
    return {
      list: []
    }
  },

  mounted () {
    let self = this
    this.APIGetActivity().then((data) => {
      self.list = data
    })
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
.list {
	border: 2px solid rgba(0,0,0,0.3);
	padding: .5rem 1rem;
	border-radius: 10px;
	display: flex;
	justify-content:space-between;
	outline:none;
	min-height: 52px;
	p {
		margin: auto 0;
	}
	img {
		width: 2rem;
		height: 2rem;
		cursor: pointer;
	}
}
.list:hover,.list:focus {
	box-shadow: 4px 4px 3px rgba(20%,20%,40%,0.4);
}
.icon {
	display: flex;
}
.icon-trash, .icon-go {
	width: 2rem;
	display: flex;
	height: 2rem;
	position: relative;
	cursor: pointer;
	img {
		position: absolute;
	}
	.icon-img-hover {
		opacity: 0;
	}
	.icon-img-hover:hover {
		opacity: 1;
	}
}
</style>